import React from 'react';

import PropTypes from 'prop-types';

import { Box, TopbarWrapper } from './css';
import ServiceListRow from './serviceListRow';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const ServiceList = ({
  businessConnectServices,
  setBusinessConnectServices,
  setEditService,
  setIsFormTouched,
  editService
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    callCentre: {
      labelServices,
      tableHeader: {
        labelServiceName,
        labelPaymentType,
        labelPrice,
        labelQuantity,
        labelActions
      }
    }
  } = localizedStrings;

  const removeService = id => {
    const updatedServicesList = businessConnectServices.filter(
      service => service.id !== id
    );
    setBusinessConnectServices(updatedServicesList);
    setIsFormTouched(true);
  };
  return (
    <Box>
      <TopbarWrapper>{`${labelServices} (${businessConnectServices.length})`}</TopbarWrapper>
      <table className="table table-bordered">
        <thead style={{ background: '#e2e2e2' }}>
          <tr>
            <th>#</th>
            <th>{labelServiceName}</th>
            <th>{labelPaymentType}</th>
            <th>{labelPrice}</th>
            <th>{labelQuantity}</th>
            <th>{labelActions}</th>
          </tr>
        </thead>
        <tbody>
          {businessConnectServices.map((item, index) => {
            const { id } = item;
            if (editService && id === editService) return null;
            return (
              <ServiceListRow
                key={id}
                rowData={item}
                setEditService={setEditService}
                removeService={removeService}
                index={index}
              />
            );
          })}
        </tbody>
      </table>
    </Box>
  );
};

ServiceList.propTypes = {
  businessConnectServices: PropTypes.arrayOf(PropTypes.any).isRequired,
  setBusinessConnectServices: PropTypes.func.isRequired,
  setEditService: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.bool.isRequired,
  editService: PropTypes.string.isRequired
};

export default ServiceList;
